var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconUploadLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconUpload",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "m1838.86 1451.576 81.14 81.37-361.566 361.566H361.566L0 1532.946l81.255-81.37 327.891 328.007h1101.708l328.006-328.007ZM962.333 25l500.285 500.285-81.14 81.37-361.795-361.681v1187.559H904.869V244.973L543.188 606.655l-81.14-81.37L962.333 25Z",
      fillRule: "evenodd"
    })));
  }
}
IconUploadLine.glyphName = 'upload';
IconUploadLine.variant = 'Line';
IconUploadLine.displayName = 'IconUploadLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconUploadLine.propTypes = {
  ...SVGIcon.propTypes
};
IconUploadLine.allowedProps = [...SVGIcon.allowedProps];
export default IconUploadLine;
export { IconUploadLine };